import Vue from 'vue'
import Vuex from 'vuex'
import global from './modules/global'
import user from './modules/user'
import auth from './modules/auth'
import network from './modules/network'
import indexeddb from './modules/indexeddb'
import favorites from './modules/favorites'
import numbering from './modules/numbering'
import portal from './modules/portal'
import navigation from './modules/navigation'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
	modules: {
		global,
		user,
		auth,
		network,
		indexeddb,
		favorites,
		numbering,
		portal,
		navigation
	},
	strict: debug,
})